import { ClearAllOutlined, Close } from "@mui/icons-material";
import { Box, Divider, IconButton, Tooltip, Typography } from "@mui/material";
import React, { memo, useState } from "react";
import { useDispatch } from "react-redux";
import { HttpClient } from "../../../../api/httpClient";
import ModalDelete from "../../../../modals/ModalDelete";
import { removeManyNotifications } from "../../../../store/features/notificationsSlice";
import { store } from "../../../../store/store";

const ClearAllButton = memo(() => {
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const handleClear = async () => {
    const ids = [...store.getState().notifications.ids];
    await HttpClient.put({
      url: "/notifications/hide",
      body: {
        ids,
      },
    });
    dispatch(removeManyNotifications(ids));
  };

  return (
    <>
      <Tooltip onClick={handleClear} title="Limpar notificações">
        <IconButton onClick={() => setOpen(true)}>
          <ClearAllOutlined />
        </IconButton>
      </Tooltip>
      <ModalDelete
        title="Limpar notificações"
        subtitle={"Todas as notificações serão ocultadas neste dispositivo"}
        open={open}
        onClose={() => setOpen(false)}
        buttonText={"Limpar"}
        onDelete={handleClear}
      />
    </>
  );
});

function NotificationsHeader({ onClose }) {
  return (
    <Box
      position={"relative"}
      p={2}
      px={3}
      py={1.5}
      pb={0}
      display={"flex"}
      alignItems={"center"}
    >
      <Typography fontSize={"1.5rem"} fontWeight={"600"}>
        Notificações
      </Typography>
      <Box flex={1} />
      <ClearAllButton />
      <Divider sx={{ mx: 1, height: 15 }} orientation="vertical" />
      <IconButton onClick={onClose} sx={{ mr: -1 }}>
        <Close />
      </IconButton>
    </Box>
  );
}

export default memo(NotificationsHeader);
